import React from "react";
import { Modal, Header } from "semantic-ui-react";

interface InvoiceMetadata {
  claimNumber: string;
  id: string;
  instruction: string;
  postedOn: string;
  state: string;
}

interface InstructionData {
  title: string;
  type: string;
  type_id: string;
  history_id?: string;
  message: string;
  metadata: InvoiceMetadata;
}

interface InstructionPopupProps {
  open: boolean;
  onClose: () => void;
  data: InstructionData;
}

const InstructionPopup: React.FC<InstructionPopupProps> = ({ open, onClose, data }) => {
  if (!data) return null;
  return (
    <Modal open={open} onClose={onClose} size="small">
      <Header>{data.title}</Header>
      <Modal.Content>
        <p><strong>Message:</strong> {data.message}</p>
        {/* <p><strong>Instruction:</strong> {data.metadata?.instruction}</p> */}
        <p><strong>Claim Number:</strong> {data.metadata?.claimNumber}</p>
        <p><strong>Posted On:</strong> {data.metadata?.postedOn}</p>
        <p><strong>Status:</strong> {data.metadata?.state}</p>
      </Modal.Content>
    </Modal>
  );
};

export default InstructionPopup;
